import React from 'react';
import { useApi, useIsMobile, useUser } from 'react-ui';
import { useAssistantModal } from '../contexts/AssistantModal';
import { AssistantLauncher } from './AssistantLauncher';
import { AssistantPanel } from './AssistantPanel';

/**
 * Renders the Beat Engineer assistant on the map for admins / super-users only
 * (gated on the `use-assistant` permission). Owns the docked chat panel when open.
 *
 * The launcher button is rendered here only on desktop (docked bottom-right). On mobile it
 * lives inside the BottomSheet, floated above its header — see BalloonEventsMobileUI — so it
 * tracks the sheet instead of overlapping the events list.
 */
export const AssistantPanelHandler: React.FC = () => {
  const { user } = useUser();
  const { apiEndpoints, apiKey } = useApi();
  const { isOpen, balloonId, close } = useAssistantModal();
  const isMobile = useIsMobile();

  if (!user?.hasPermission('use-assistant')) {
    return null;
  }

  if (isOpen) {
    return (
      <AssistantPanel
        endpoints={{
          assistantConversations: apiEndpoints.assistantConversations,
          assistantChat: apiEndpoints.assistantChat,
        }}
        apiKey={apiKey}
        balloonId={balloonId}
        onClose={close}
      />
    );
  }

  if (isMobile) {
    return null;
  }

  return <AssistantLauncher className="absolute bottom-20 right-2.5 z-40" />;
};
